import { Button } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import { useRouter } from 'src/routes/hooks';

interface BackBtnProps {
  backUrl?: string;
  iconOnly?: boolean;
  size?: 'small' | 'medium' | 'large';
  children?: React.ReactNode;
}

export default function BackBtn({
  backUrl,
  iconOnly = false,
  size = 'medium',
  children = 'Back',
}: BackBtnProps) {
  const router = useRouter();

  const handleBack = () => {
    if (backUrl) {
      router.push(backUrl);
    } else {
      router.back();
    }
  };

  return (
    <Button
      variant="text"
      onClick={handleBack}
      startIcon={<ArrowBackOutlinedIcon fontSize={size} />}
      sx={{
        color: 'text.primary',
        fontSize: '18px',
        fontWeight: 500,
        '&:hover': {
          color: 'text.secondary',
          backgroundColor: 'transparent',
          textDecoration: 'underline',
        },
      }}
    >
      {iconOnly ? null : children}
    </Button>
  );
}
